import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import EdgeIntersectionList from './EdgeIntersectionList';
import IntersectionMatrix from '../geom/IntersectionMatrix';
import MonotoneChainEdge from './index/MonotoneChainEdge';
import Position from './Position';
import Coordinate from '../geom/Coordinate';
import Label from './Label';
import Envelope from '../geom/Envelope';
import StringBuilder from '../../../../java/lang/StringBuilder';
import Depth from './Depth';
import GraphComponent from './GraphComponent';
var Edge = /*#__PURE__*/function (_GraphComponent) {
  _inherits(Edge, _GraphComponent);
  function Edge() {
    var _this;
    _classCallCheck(this, Edge);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Edge).call(this));
    Edge.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(Edge, [{
    key: "getDepth",
    value: function getDepth() {
      return this._depth;
    }
  }, {
    key: "getCollapsedEdge",
    value: function getCollapsedEdge() {
      var newPts = new Array(2).fill(null);
      newPts[0] = this.pts[0];
      newPts[1] = this.pts[1];
      var newe = new Edge(newPts, Label.toLineLabel(this._label));
      return newe;
    }
  }, {
    key: "isIsolated",
    value: function isIsolated() {
      return this._isIsolated;
    }
  }, {
    key: "getCoordinates",
    value: function getCoordinates() {
      return this.pts;
    }
  }, {
    key: "setIsolated",
    value: function setIsolated(isIsolated) {
      this._isIsolated = isIsolated;
    }
  }, {
    key: "setName",
    value: function setName(name) {
      this._name = name;
    }
  }, {
    key: "equals",
    value: function equals(o) {
      if (!(o instanceof Edge)) return false;
      var e = o;
      if (this.pts.length !== e.pts.length) return false;
      var isEqualForward = true;
      var isEqualReverse = true;
      var iRev = this.pts.length;
      for (var i = 0; i < this.pts.length; i++) {
        if (!this.pts[i].equals2D(e.pts[i])) isEqualForward = false;
        if (!this.pts[i].equals2D(e.pts[--iRev])) isEqualReverse = false;
        if (!isEqualForward && !isEqualReverse) return false;
      }
      return true;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      if (arguments.length === 0) {
        if (this.pts.length > 0) return this.pts[0];
        return null;
      } else if (arguments.length === 1) {
        var i = arguments[0];
        return this.pts[i];
      }
    }
  }, {
    key: "print",
    value: function print(out) {
      out.print('edge ' + this._name + ': ');
      out.print('LINESTRING (');
      for (var i = 0; i < this.pts.length; i++) {
        if (i > 0) out.print(',');
        out.print(this.pts[i].x + ' ' + this.pts[i].y);
      }
      out.print(')  ' + this._label + ' ' + this._depthDelta);
    }
  }, {
    key: "computeIM",
    value: function computeIM(im) {
      Edge.updateIM(this._label, im);
    }
  }, {
    key: "isCollapsed",
    value: function isCollapsed() {
      if (!this._label.isArea()) return false;
      if (this.pts.length !== 3) return false;
      if (this.pts[0].equals(this.pts[2])) return true;
      return false;
    }
  }, {
    key: "isClosed",
    value: function isClosed() {
      return this.pts[0].equals(this.pts[this.pts.length - 1]);
    }
  }, {
    key: "getMaximumSegmentIndex",
    value: function getMaximumSegmentIndex() {
      return this.pts.length - 1;
    }
  }, {
    key: "getDepthDelta",
    value: function getDepthDelta() {
      return this._depthDelta;
    }
  }, {
    key: "getNumPoints",
    value: function getNumPoints() {
      return this.pts.length;
    }
  }, {
    key: "printReverse",
    value: function printReverse(out) {
      out.print('edge ' + this._name + ': ');
      for (var i = this.pts.length - 1; i >= 0; i--) out.print(this.pts[i] + ' ');
      out.println('');
    }
  }, {
    key: "getMonotoneChainEdge",
    value: function getMonotoneChainEdge() {
      if (this._mce === null) this._mce = new MonotoneChainEdge(this);
      return this._mce;
    }
  }, {
    key: "getEnvelope",
    value: function getEnvelope() {
      if (this._env === null) {
        this._env = new Envelope();
        for (var i = 0; i < this.pts.length; i++) this._env.expandToInclude(this.pts[i]);
      }
      return this._env;
    }
  }, {
    key: "addIntersection",
    value: function addIntersection(li, segmentIndex, geomIndex, intIndex) {
      var intPt = new Coordinate(li.getIntersection(intIndex));
      var normalizedSegmentIndex = segmentIndex;
      var dist = li.getEdgeDistance(geomIndex, intIndex);
      var nextSegIndex = normalizedSegmentIndex + 1;
      if (nextSegIndex < this.pts.length) {
        var nextPt = this.pts[nextSegIndex];
        if (intPt.equals2D(nextPt)) {
          normalizedSegmentIndex = nextSegIndex;
          dist = 0.0;
        }
      }
      var ei = this.eiList.add(intPt, normalizedSegmentIndex, dist);
    }
  }, {
    key: "toString",
    value: function toString() {
      var builder = new StringBuilder();
      builder.append('edge ' + this._name + ': ');
      builder.append('LINESTRING (');
      for (var i = 0; i < this.pts.length; i++) {
        if (i > 0) builder.append(',');
        builder.append(this.pts[i].x + ' ' + this.pts[i].y);
      }
      builder.append(')  ' + this._label + ' ' + this._depthDelta);
      return builder.toString();
    }
  }, {
    key: "isPointwiseEqual",
    value: function isPointwiseEqual(e) {
      if (this.pts.length !== e.pts.length) return false;
      for (var i = 0; i < this.pts.length; i++) if (!this.pts[i].equals2D(e.pts[i])) return false;
      return true;
    }
  }, {
    key: "setDepthDelta",
    value: function setDepthDelta(depthDelta) {
      this._depthDelta = depthDelta;
    }
  }, {
    key: "getEdgeIntersectionList",
    value: function getEdgeIntersectionList() {
      return this.eiList;
    }
  }, {
    key: "addIntersections",
    value: function addIntersections(li, segmentIndex, geomIndex) {
      for (var i = 0; i < li.getIntersectionNum(); i++) this.addIntersection(li, segmentIndex, geomIndex, i);
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this.pts = null;
      this._env = null;
      this.eiList = new EdgeIntersectionList(this);
      this._name = null;
      this._mce = null;
      this._isIsolated = true;
      this._depth = new Depth();
      this._depthDelta = 0;
      if (arguments.length === 1) {
        var pts = arguments[0];
        Edge.constructor_.call(this, pts, null);
      } else if (arguments.length === 2) {
        var _pts = arguments[0],
          label = arguments[1];
        this.pts = _pts;
        this._label = label;
      }
    }
  }, {
    key: "updateIM",
    value: function updateIM() {
      if (arguments.length === 2 && arguments[1] instanceof IntersectionMatrix && arguments[0] instanceof Label) {
        var label = arguments[0],
          im = arguments[1];
        im.setAtLeastIfValid(label.getLocation(0, Position.ON), label.getLocation(1, Position.ON), 1);
        if (label.isArea()) {
          im.setAtLeastIfValid(label.getLocation(0, Position.LEFT), label.getLocation(1, Position.LEFT), 2);
          im.setAtLeastIfValid(label.getLocation(0, Position.RIGHT), label.getLocation(1, Position.RIGHT), 2);
        }
      } else {
        return _get(_getPrototypeOf(Edge), "updateIM", this).apply(this, arguments);
      }
    }
  }]);
  return Edge;
}(GraphComponent);
export { Edge as default };